import Glider from 'glider-js';
import { MQ } from '../tools/MQ.js';
import debounce from 'lodash.debounce';

export const init = () => {
	let jsAdvantageCarousel, glider, initializedCarousel;

	glider = [];
	initializedCarousel = false;

	const setAdvantageCarousel = () => {
		jsAdvantageCarousel = document.querySelectorAll('.js-advantage-carousel');

		if (jsAdvantageCarousel.length > 0) {
			if (MQ('mdDown')) {
				if (!initializedCarousel) {
					Array.from(jsAdvantageCarousel).forEach((item, index) => {
						glider[index] = new Glider(item, {
							slidesToShow: 1,
							slidesToScroll: 1,
							draggable: true,
							dots: item.nextElementSibling,
							scrollLock: true,
							responsive: [
								{
									breakpoint: 750,
									settings: {
										dots: false,
										slidesToScroll: 'auto',
									},
								},
							],
						});

						if (glider[index].slides.length === 1) {
							item.classList.toggle('l-advantage__list--alone');
							glider[index].setOption({
								draggable: false,
								responsive: [
									{
										breakpoint: 750,
										settings: {
											dots: false,
										},
									},
								],
							});
							glider[index].destroy();
						}
					});
					initializedCarousel = true;
				}
			} else {
				if (initializedCarousel) {
					Array.from(glider).forEach((item) => {
						item.destroy();
					});
					initializedCarousel = false;
				}
			}
		}
	};

	setAdvantageCarousel();
	$(window).on('resize', debounce(setAdvantageCarousel, 200));
};
